import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Box,
  Menu,
  MenuItem,
  Avatar,
  Divider
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import ChangePasswordDialog from './ChangePasswordDialog';

const Header = ({ onMenuToggle }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleLogout = () => {
    logout();
    handleMenuClose();
  };
  
  const handleChangePassword = () => {
    setPasswordDialogOpen(true);
    handleMenuClose();
  };

  return (
    <>
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        {isAuthenticated && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        
        <Typography 
          variant="h6" 
          component={RouterLink} 
          to="/" 
          sx={{ 
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit'
          }}
        >
          MRHI Generator
        </Typography>
        
        {isAuthenticated ? (
          <Box>
            <Button 
              color="inherit" 
              onClick={handleMenuOpen}
              endIcon={<AccountCircleIcon />}
            >
              {user?.username || 'Account'}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem 
                component={RouterLink} 
                to="/profile" 
                onClick={handleMenuClose}
              >
                Profile
              </MenuItem>
              <MenuItem onClick={handleChangePassword}>
                <LockIcon sx={{ mr: 1, fontSize: 20 }} />
                Change Password
              </MenuItem>
              {user?.is_admin && (
                <>
                  <Divider />
                  <MenuItem 
                    component={RouterLink} 
                    to="/admin" 
                    onClick={handleMenuClose}
                  >
                    Admin Panel
                  </MenuItem>
                </>
              )}
              <Divider />
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        ) : (
          <Box>
            <Button 
              color="inherit" 
              component={RouterLink} 
              to="/login"
              sx={{ mr: 1 }}
            >
              Login
            </Button>
            <Button 
              color="inherit" 
              component={RouterLink} 
              to="/register"
              variant="outlined"
            >
              Register
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
    
    {/* Change Password Dialog */}
    <ChangePasswordDialog 
      open={passwordDialogOpen} 
      onClose={() => setPasswordDialogOpen(false)} 
    />
    </>
  );
};

export default Header;